<div class="modal-body swq-body">

    <!-- Top row: title + close -->
    <div class="swq-top">
        <h2 class="swq-title">{{ displayName }}</h2>
        <button class="swq-close" type="button" (click)="modal.dismiss()" aria-label="Close">&times;</button>
    </div>

    <ng-container *ngIf="rows.length > 0; else noAnswers">

        <!-- Questions table -->
        <table class="swq-table">
            <thead>
                <tr>
                    <th class="swq-th swq-th--num">#</th>
                    <th class="swq-th">Question</th>
                    <th class="swq-th swq-th--score">Score</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of rows" class="swq-row">
                    <td class="swq-td swq-td--num">{{ row.num }}</td>
                    <td class="swq-td">
                        <span class="swq-question-pill">{{ row.label }}</span>
                    </td>
                    <td class="swq-td swq-td--score">
                        <ng-container *ngIf="row.value !== null; else notApplicable">
                            <ng-container *ngIf="isScaleQuestion(row.num); else numericBadge">
                                <span class="swq-scale-label">{{ getScaleLabel(row.value) }}</span>
                            </ng-container>
                            <ng-template #numericBadge>
                                <span class="swq-score-badge">{{ row.value }}</span>
                            </ng-template>
                        </ng-container>
                        <ng-template #notApplicable>
                            <cdss-weekly-state-label state="notApplicable"></cdss-weekly-state-label>
                        </ng-template>
                        <cdss-trend-icon [trend]="row.trend"></cdss-trend-icon>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Footer -->
        <div class="swq-footer" *ngIf="totalScore != null">
            <span class="swq-footer__label">
                Results
                <span class="swq-severity-chip" *ngIf="severity">{{ severity }}</span>
            </span>
            <span class="swq-footer__total">
                Total Score
                <span class="swq-score-badge swq-score-badge--lg">{{ totalScore | number:'1.0-2' }}</span>
                <cdss-trend-icon [trend]="trend"></cdss-trend-icon>
            </span>
        </div>

    </ng-container>

    <ng-template #noAnswers>
        <div class="alert alert-warning mb-0">No answers available.</div>
    </ng-template>

</div>
